import { render, staticRenderFns } from "./FiltersNav.vue?vue&type=template&id=68ab07d6&lang=pug&"
import script from "./FiltersNav.vue?vue&type=script&lang=js&"
export * from "./FiltersNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports